import type { SxProps, Theme } from '@mui/material/styles';

export const autocompleteSx: SxProps<Theme> = {
  minWidth: 200,
};

export const getInputFieldSx = (theme: Theme): SxProps<Theme> => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#F7F7F8',
    borderRadius: '0.5rem',
    fontSize: '0.875rem',
    maxHeight: '100px',
    overflowY: 'auto',
    '& fieldset': { borderColor: '#E0DFE5' },
    '&:hover fieldset': { borderColor: '#BCBAC7' },
    '&.Mui-focused fieldset': { borderColor: theme.palette.accent.main },
    '&.MuiInputBase-root.MuiAutocomplete-inputRoot': { paddingLeft: '1rem' },
    '& .MuiAutocomplete-input.MuiAutocomplete-input': { paddingLeft: 0 },
    '& .MuiAutocomplete-endAdornment': { right: '1rem' },
    '& .MuiAutocomplete-popupIndicator': { padding: 0, marginRight: 0 },
  },
  '& .MuiChip-deleteIcon': { marginLeft: '0.25rem !important' },
});
